<div class="reports tabs-content" data-tabs-content="report-tabs">
  <div class="reports tabs-panel is-active" id="tools">
    <div class="row tools-grids">
      <div class="tool-grid" (click)="showPage('user-history-report', $event)">
        <div class="grid-icon billing"></div>
        <div class="clear"></div>
        <div class="thumb-label">User History</div>
      </div>
    </div>
  </div>
</div>
